import orderBy from 'lodash/orderBy';
import memoize from 'lodash/memoize';
import cloneDeep from 'lodash/cloneDeep';
import { allFilter, sortingMethods } from './GrowthReports/reportDetails';
import tabDetails from '../components/Navigation/tabDetails';
import Settings from '../resources/settings';

export const getReportDetails = (reportIdentifiers, reportDetails = []) => {
  return !Array.isArray(reportIdentifiers)
    ? []
    : reportDetails.filter((details) => {
        return reportIdentifiers.includes(details.identifier);
      });
};

export const sortCards = (reportDetails, sortingMethod) => {
  // Why bother having a sorting function?
  //
  // Because the plan is to have the recommended order be dynamic, and based on multiple weighting factors,
  // such as time of year, whatImDoing filter selection and others, so this function can be added to in future
  // adding the various weighting factors together should result in a dynamic overall recommended weight i.e.
  //
  // return sortingWeights.recommended + if(isSpring) ? sortingWeights.timeOfYear.spring : 0 + sortingWeights.other ...
  // Highest combined weight is nearest the top of the list
  //
  const recommendedSortingFn = (reportDefinition) => {
    return reportDefinition.sortingWeights.recommended;
  };

  let sortedResult;
  switch (sortingMethod) {
    case sortingMethods.asc:
    case sortingMethods.desc: {
      sortedResult = orderBy(reportDetails, ['title'], [sortingMethod]);
      break;
    }
    case sortingMethods.recommended: {
      sortedResult = orderBy(reportDetails, [recommendedSortingFn], [sortingMethods.desc]);
      break;
    }
    default: {
      console.warn(`An unrecognized sorting method ${sortingMethod} was specified, returning unsorted list`);
      sortedResult = reportDetails;
      break;
    }
  }
  return sortedResult;
};

export const filterGrowthReports = memoize(
  (reportDetails, levelFilter, whatImDoingFilter, sortingMethod) => {
    return sortCards(
      reportDetails.filter((reportDetail) => {
        let passesFilter = true;
        if (levelFilter && levelFilter !== allFilter) {
          passesFilter = reportDetail.filter.level.includes(levelFilter);
        }

        if (passesFilter && whatImDoingFilter && whatImDoingFilter !== allFilter) {
          passesFilter = reportDetail.filter.whatImDoing.includes(whatImDoingFilter);
        }
        return passesFilter;
      }),
      sortingMethod
    );
  },
  (reportDetails, levelFilter, whatImDoingFilter, sortingMethod) => {
    return `${levelFilter}-${whatImDoingFilter}-${sortingMethod}`;
  }
);

export const updateHeaderHelpLink = memoize((location, menus) => {
  const map = tabDetails.growthReports.urlEndPoint;
  const operational = tabDetails.operationalReports.urlEndPoint;
  const newMenu = cloneDeep(menus);
  let helpMenuOptions = newMenu.secondaryMenuItems.find((x) => x.displayText === 'Help');
  if (helpMenuOptions) {
    helpMenuOptions.external = true;
    if (location.includes(map) || location.includes(operational)) {
      helpMenuOptions.link = `${Settings.ADMIN_BASE_PATH}/assist/help_map/ApplicationHelp.htm#cshid=802`;
    } else {
      helpMenuOptions.link = `${Settings.ADMIN_BASE_PATH}/assist/help_map/ApplicationHelp.htm#cshid=803`;
    }
  }
  return newMenu;
});

/**
 * This will remove the transition classNames and timeout for browsers which do not support transitions
 * @param transitionOptions the transition options
 * @param browserName the name of the browser
 * @returns {*} the transitionOptions, augmented for the supplied browser
 */
export const browserRemoveTransition = (transitionOptions, browserName) => {
  const browsersWithoutTransitions = ['edge'];
  const newOptions = Object.assign({}, transitionOptions);
  if (browsersWithoutTransitions.includes(browserName)) {
    newOptions.classNames = {};
    newOptions.timeout = 0;
  }
  return newOptions;
};

export function getAvailableReports(reportDetails, additionalReports = []) {
  return reportDetails.reduce((acc, report) => {
    if (report.isEnabled) {
      acc.push(report.identifier);
    }
    return acc;
  }, additionalReports);
}

export default {
  getReportDetails,
  sortCards,
  filterGrowthReports,
  updateHeaderHelpLink,
  browserRemoveTransition,
  getAvailableReports,
};
